import { capitalize } from "@smile2impress/attraction-utils";

import { Schedule } from "types/clinic";

export const formatSchedule = (schedule: Schedule[]) => {
    return schedule
        .map((workingDay) => {
            const { day, time } = workingDay;
            const [opens, closes] = time
                .split("-")
                .map((el: string) => el.trim());
            if (!closes) return null;
            return {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: {
                    "@type": "DayOfWeek",
                    name: capitalize(day),
                },
                opens: `${opens}:00`,
                closes: `${closes}:00`,
            };
        })
        .filter((el) => el);
};
